import { useApolloClient } from '@apollo/client/react';
import { useEffect } from 'react';

import { clearSession } from '@/api/session';
import { subscribeSessionMessages } from '@/api/session-channel';
import { getUserToken } from '@/shared/services/user-hash';
import { useAppDispatch } from '@/store';
import { setIsAuthorized } from '@/store/auth.slice';

/**
 * Держит вкладку в одной сессии с остальными: выход в любой вкладке сбрасывает
 * токен, данные и экран здесь же, вход — открывает кабинет без повторного входа
 * (токен в куке общий для вкладок).
 */
const useSessionSync = (): void => {
  const client = useApolloClient();
  const dispatch = useAppDispatch();

  useEffect(
    () =>
      subscribeSessionMessages((message) => {
        if (message.type === 'logout') {
          void clearSession(client, { broadcast: false });
          return;
        }
        if (getUserToken().accessToken) dispatch(setIsAuthorized(true));
      }),
    [client, dispatch]
  );
};

export default useSessionSync;
